import { Box, Container, Stack, Typography, Grid } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationRounded from '@mui/icons-material/LocationOnRounded';
import FacebookRounded from '@mui/icons-material/FacebookRounded';
import WhatsAppRounded from '@mui/icons-material/WhatsApp';

const BrandSolicita = () => {
  const boxGrid = { padding: {xs: "8px", lg:"24px"}, justifyItems: "center",};
  const stack = {
    minWidth:"100%",
  };
  const stackBoxUno = {margin: "0"};
  const stackBoxDos = {   
    bgcolor:"rgb(255, 255, 255)",
    borderRadius:"50%",
    height:"56px",
    width:"56px",
    padding:"9.6px"};
  const typography = {   
    fontSize: {xs: "14px", sm: "18px", md:"22px"}, 
    ml:"8px",
    fontWeight: "400",
    lineHeight: "1.43",
    textAlign: "left",
    display: "flex",
    alignItems: "center",
    color: "rgb(255, 255, 255)",
      '&:hover': {
      textDecoration: "none",
      color: "#ffda00",
      transition: "1s"
    },
  };
    
  const link = {
    outline: 'none',
    display: 'contents',
    textDecoration: 'none',
  }

    return (
      <Box className="fullWidth" sx={{
        pt: "24px",
        mb: "16px",
        backgroundColor: "rgb(25, 91, 224)",
      }}>
        <Container className="centeredContainer" sx={{
          width: "100%",
          ml: "auto",
          mr: "auto",
          pl: "16px",
          pr: "16px",
          position: "relative",
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          mb: "24px",
          gap: "24px",
        }}>
          <Typography variant="h2" sx={{
            margin: "0px",
            lineHeight: "1.167",
            textAlign: "center",
            padding: "9.6px",
            fontWeight: "900",
            color: "rgb(255, 255, 255)",
            width: {xs:"100%", sm:"85%"},
          }}>
            Solicita mayor información sobre nuestros planes y/o contrata el tuyo:
          </Typography>

          <Grid container  sx={{
            display: "flex",
            flexFlow: "wrap",
            width: "100%",
            justifyContent: {xs: "space-between", md:"center"},
            maxWidth: {xs: "100%", lg:"80%"},
            margin: "0 !important",
          }}>
            <Grid item sx={boxGrid} xs={12} sm={6}>
              <Stack display="flex" flexDirection="row" textAlign="center" sx={stack}>
                <Box sx={stackBoxUno}>
                  <Box sx={stackBoxDos}>
                    <PhoneIcon sx={{fontSize: "32px"}} />
                  </Box>
                </Box>

                <Box component="a" href="tel:3112119470" target="_blank" sx={link}>
                  <Typography variant="h4" textAlign="left" sx={typography}>
                    (311) 211 9470 Ext. 192
                  </Typography>
                </Box>
              </Stack>
            </Grid>

            <Grid item sx={boxGrid} xs={12} sm={6}>
              <Stack display="flex" flexDirection="row" textAlign="center" sx={stack}>
                <Box sx={stackBoxUno}>
                  <Box sx={stackBoxDos}>
                    <WhatsAppRounded sx={{fontSize: "32px", color: "rgb(109, 219, 86)"}} />
                  </Box>
                </Box>

                <Box component="a" href="https://wa.me/3111006075" target="_blank" sx={link}>
                  <Typography variant="h4" textAlign="left" sx={typography}>
                    (311) 100 6075
                  </Typography>
                </Box>
              </Stack>
            </Grid>

            <Grid item sx={boxGrid} xs={12} sm={6}>
              <Stack display="flex" flexDirection="row" textAlign="center" sx={stack}>
                <Box sx={stackBoxUno}>
                  <Box sx={stackBoxDos}>
                    <LocationRounded sx={{fontSize: "32px", color: "rgb(214, 0, 28)"}} />
                  </Box>
                </Box>

                <Box component="a" href="https://maps.app.goo.gl/f91W5SNMHRu133Ek8" target="_blank" sx={link}>
                  <Typography variant="h4" textAlign="left" sx={typography}>
                    Av. del Valle #91, Cd. del Valle, Tepic, Nay.
                  </Typography>
                </Box>
              </Stack>
            </Grid>

            <Grid item sx={boxGrid} xs={12} sm={6}>
              <Stack display="flex" flexDirection="row" textAlign="center" sx={stack}>
                <Box sx={stackBoxUno}>
                  <Box sx={stackBoxDos}>
                    <FacebookRounded sx={{fontSize: "32px", color: "rgb(25, 91, 224)"}} />
                  </Box>
                </Box>

                <Box component="a" href="https://www.facebook.com/MembresiaSalud365" target="_blank" sx={link}>
                  <Typography variant="h4" textAlign="left" sx={typography}>
                    MembresiaSalud365
                  </Typography>
                </Box>
              </Stack>
            </Grid>

          </Grid>
        </Container>
      </Box>
    );
};
export default BrandSolicita;
